import React from 'react';
import { Center, VStack, Heading, Text, Spinner, HStack } from '@chakra-ui/react';
import { ApplicationUI } from '../../../ui';
import { PluginMissingState, SubscriptionAddonProps } from './subscriptionAddonProps';
import { ValueFormatter } from '../../../app/attributes';

const createPluginMissingView = ({UI}: {UI: ApplicationUI}): React.FC<{ type: PluginMissingState, }> => ({ type }) => {
    if(type === 'loading') {
        return <Spinner />;
    }
    if(type === 'error') {
        return <UI.Text colorScheme='red'>Encountered Error loading your subscription</UI.Text>
    }
    if(type === 'loaded' || type === 'empty') {
        return <></>;
    }
    if(type === 'no_plan') {
        return <UI.Text color='red'>Could not find your current plan</UI.Text>;
    }
    return <UI.Text color='red'>Your plan does not include top creatives extended reporting</UI.Text>;
}

export const createGroupsSubscriptionAddonView = ({ UI, formatter }: {
    UI: ApplicationUI, formatter: ValueFormatter
}): React.FC<SubscriptionAddonProps> => {
    const PluginMissingView = createPluginMissingView({UI});
    return (props) => {
        if(typeof props.plugin === 'string') {
            return <Center w='full' h='full'>
                <PluginMissingView type={props.plugin} />
            </Center>
        } else {
            return <VStack spacing={3}>
            <UI.Heading>
                Top Creatives - Premium
            </UI.Heading>
            <UI.Text>
                Top creatives is a premium feature that requires the {props.plugin.name} subscription addon.
            </UI.Text>
            <UI.Text>
                Pay {formatter.format({ kind: 'currency', currency: props.plugin.currency, constraints: []}, props.plugin.amount / 100 )}/mo and add the {props.plugin.name} to your subscription.
            </UI.Text>
            <HStack spacing={2}>
                {props.plugin.isInstalled ? (
                    <UI.Button isLoading={props.saveState.isLoading} onClick={props.onUnSubscribe}>
                        Remove from your plan
                    </UI.Button>
                ): <UI.Button isLoading={props.saveState.isLoading} colorScheme="green" onClick={props.onSubscribe}>
                    Add {props.plugin.name}
                </UI.Button>
                }
                {props.saveState.shouldCreatePaymentMethod && <UI.Button
                    isLoading={props.createPaymentMethod.isLoading} onClick={props.createPaymentMethod.mutate} variant='outline'>Add Payment Method</UI.Button>
                }
            </HStack>
            {
                props.saveState.isError && <UI.Text color='red'>{props.saveState.error ?  props.saveState.error.message: 'Unexpected error occured while modifing your billing plan. please retry later'}</UI.Text>
            }
            {
                props.createPaymentMethod.isError && <UI.Text color='red'>Unexpected error occured while processing the request. please retry later</UI.Text>
            }
        </VStack>
        };
    }
}